<template>
  <v-tooltip top>
    <template slot="activator">
      <v-dialog
        v-if="!splitted"
        v-model="dialog"
        width="500"
        :disabled="disabled"
      >
        <v-btn
          slot="activator"
          small
          icon
          class="my-0"
          :disabled="disabled"
        >
          <v-icon>
            call_split
          </v-icon>
        </v-btn>
        <v-card>
          <v-card-title>
            <h1 class="headline">
              Разбивка поставки
            </h1>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-textarea
                v-model="reason"
                label="Причина"
                :rules="reasonRules"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              color="primary"
              :disabled="!valid"
              :loading="loading"
              @click="splitShipping"
            >
              Разбить
            </v-btn>
            <v-btn
              small
              @click="dialog = false"
            >
              Отмена
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-menu
        v-else
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="400"
        offset-x
        top
      >
        <v-btn
          slot="activator"
          small
          icon
          class="my-0"
        >
          <v-icon>
            call_split
          </v-icon>
        </v-btn>
        <v-card>
          <v-card-text>
            <h3>Причина разбивки</h3>
            {{ splitReason }}
            <h3 class="mt-3 mb-2">
              Производные поставки
            </h3>
            <v-data-table
              hide-actions
              hide-headers
              :items="derrivedShippings"
              class="elevation-1"
            >
              <template
                slot="items"
                slot-scope="props"
              >
                <td><a @click="$router.push({name: 'shipping', params:{id: props.item.id.toString()}})">{{ props.item.number }}</a></td>
                <td>{{ props.item.date }}</td>
              </template>
            </v-data-table>
            <!-- <v-btn small
                   :disabled="childrenIsSplitted"
                   block
                   @click="cancelDialog = true">
                     Отменить разбивку
                  </v-btn> -->
            <v-dialog
              v-model="cancelDialog"
              width="500"
              style="width:100%"
            >
              <v-btn
                :slot="childrenIsSplitted?'':'activator'"
                small
                block
              >
                Отменить разбивку
              </v-btn>
              <v-card>
                <v-card-title>
                  <h2 class="headline">
                    Вы уверены, что хотите отменить разбивку?
                  </h2>
                </v-card-title>
                <v-card-actions>
                  <v-btn
                    small
                    color="primary"
                    :loading="loading"
                    @click="revertSplit"
                  >
                    Ok
                  </v-btn>
                  <v-btn
                    small
                    @click="cancelDialog = false"
                  >
                    Отмена
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <splited-tree
              :id="id"
              v-model="splitedTreeDialog"
              :shipping-number="id"
            />
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
    <span>Разбивка поставки</span>
  </v-tooltip>
</template>

<script>
import * as shippingsApi from "../../../../backend/shippingsApi.js";
import SplitedTree from "./SplitedTreeDialog.vue";

export default {
  components: {
    SplitedTree,
  },
  props: ["id", "splitted", "disabled"],
  data() {
    return {
      derrivedShippings: [],
      menu: false,
      loading: false,
      dialog: false,
      reason: "",
      valid: false,
      reasonRules: [(v) => !!v || "Необходимо заполнить причину"],
      cancelDialog: false,
      splitedTreeDialog: false,
      childrenIsSplitted: false,
    };
  },
  computed: {
    splitReason() {
      return this.$store.getters["shipping/splitReason"];
    },
  },
  watch: {
    menu(value) {
      if (value) {
        this.loadDerrived();
      }
    },
  },
  methods: {
    async splitShipping() {
      this.loading = true;
      await shippingsApi.createSplitShipping(this.id, this.reason);
      await this.$store.dispatch("shipping/getShipping", this.id);
      this.loading = false;
      this.dialog = false;
    },
    async loadDerrived() {
      const res = await shippingsApi.loadShippingDerrived(this.id);
      this.derrivedShippings = res.data.map((s) => {
        return {
          id: s.Id,
          number: s.Number,
          date: this.$options.filters.dateTime(s.Date),
          state: s.State,
        };
      });
      const childWithStateSplitted = this.derrivedShippings.find((item) => {
        return item.state === 15;
      });
      this.childrenIsSplitted = childWithStateSplitted !== undefined;
    },
    async revertSplit() {
      this.loading = true;
      await shippingsApi.revertShippingSplit(this.id);
      await this.$store.dispatch("shipping/getShipping", this.id);
      this.loading = false;
      this.cancelDialog = false;
      this.menu = false;
    },
  },
};
</script>
